<template>
    <div>
        <div v-if="!this.user.orgaValid">
            <v-overlay :value="true" z-index="4">
                <v-alert type="error" prominent>
                    {{ $vuetify.lang.t('$vuetify.dashboard.oragnizationCannotBeUsedRentalPeriod1') }} 
                    {{this.user.orgaName}} 
                    {{ $vuetify.lang.t('$vuetify.dashboard.oragnizationCannotBeUsedRentalPeriod2') }}
                </v-alert>
            </v-overlay> 
        </div>
        <v-row justify="space-around">
            <v-col cols="12" lg="7">
                <StatusCard class="fill-height" />
            </v-col>
            <v-col cols="12" lg="5">
                <AlarmsRecapCard class="fill-height" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="7">
                <StatisticsCard class="fill-height" />
            </v-col>
            <v-col cols="12" lg="5">
                <IntrusionsRecapCard class="fill-height"/>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import StatusCard from './Dashboard/StatusCard';
import StatisticsCard from './Dashboard/StatisticsCard';
import AlarmsRecapCard from './Dashboard/AlarmsRecapCard';
import IntrusionsRecapCard from './Dashboard/IntrusionsRecapCard';
import { mapGetters } from 'vuex';

export default {
    name: "Dashboard",
    components: {
        StatusCard,
        AlarmsRecapCard,
        IntrusionsRecapCard,
        StatisticsCard
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
    }
}
</script>